import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import SubmitButton from 'forms/shared/buttons/submit'
import leadsActions from 'actions/leads/actions'
import ScheduleTourForm from './form'

const ScheduleTour = ({
  user,
  isAuth,
  selectedSpace = {},
  scheduleTour,
  setActiveModal,
  setSelected,
  spaces,
  place,
  notification: { type },
}) => {
  const formName = 'public-schedule-tour-form'
  const { email, profile, name } = user
  const { id: spaceId } = selectedSpace

  return (
    <div>
      {!isAuth && (
        <p className="text-md text-center">
          <span
            className="text-primary-orange underline cursor-pointer mr-1 font-normal"
            onClick={() => setActiveModal('sign-in')}
          >
            Sign in
          </span>
          if you&apos;re a member.
        </p>
      )}
      {type === 'success' && setActiveModal('success')}
      <ScheduleTourForm
        form={formName}
        isAuth={isAuth}
        initialValues={{ email, fullName: name, space: { value: spaceId, preFormatted: selectedSpace }, ...profile }}
        spaceOptions={spaces}
        onSubmit={values => {
          scheduleTour({ isAuth, place, ...values })
          setSelected(values)
        }}
      />
      <div className="modal-footer justify-center flex">
        <SubmitButton className="btn btn-primary font-normal mx-3 w-full" formName={formName}>
          Submit
        </SubmitButton>
      </div>
    </div>
  )
}

ScheduleTour.propTypes = {
  user: PropTypes.object,
  scheduleTour: PropTypes.func,
  isAuth: PropTypes.bool,
  selectedSpace: PropTypes.object,
  setActiveModal: PropTypes.func.isRequired,
  setSelected: PropTypes.func.isRequired,
  notification: PropTypes.object.isRequired,
  spaces: PropTypes.array,
  place: PropTypes.string,
}

const mapStateToProps = ({ auth, notification }) => ({
  isAuth: auth.authenticated,
  user: auth.user || {},
  notification,
})

const mapDispatchToProps = {
  scheduleTour: leadsActions.scheduleTour,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ScheduleTour)
